import { Error401Container } from 'src/containers/Error/401/401';

export const Error401 = () => {
  return <Error401Container />;
};
